<template>
  <DropdownMenu>
    <!-- Floating trigger button - grouped with darkmode toggle at bottom-left -->
    <DropdownMenuTrigger as-child>
      <button
        class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-700 text-gray-100 shadow-md hover:shadow-lg focus:outline-none gap-1 cursor-pointer"
        :title="'Switch language'"
      >
        <span class="text-base">{{ currentLocaleCode }}</span>
      </button>
    </DropdownMenuTrigger>

    <!-- Dropdown with language options -->
    <DropdownMenuContent
      align="start"
      class="w-40 p-2"
    >
      <DropdownMenuItem
        v-for="locale in locales"
        :key="locale.code"
        :class="{ 'font-bold text-primary': i18n.locale.value === locale.code }"
        class="cursor-pointer hover:bg-accent rounded-md px-3 py-2 flex items-center gap-3 transition-colors"
        @click.prevent="changeLocale(locale.code)"
      >
        <span class="text-lg">{{ locale.emoji }}</span>
        <span>{{ locale.label }}</span>
        <span
          v-if="i18n.locale.value === locale.code"
          class="ml-auto text-primary"
        > ✓ </span>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

const i18n = useI18n()

/** Available locales with display names */
const locales = [
  { code: 'en', label: 'English', emoji: '🇬🇧' },
  { code: 'de', label: 'Deutsch', emoji: '🇩🇪' },
  { code: 'da', label: 'Dansk', emoji: '🇩🇰' },
  { code: 'kr', label: '한국어', emoji: '🇰🇷' },
]

/** Get emoji + short code for badge display */
const currentLocaleCode = computed(
  () => locales.find((l) => l.code === i18n.locale.value)?.emoji || '🌐',
)

/** Change locale handler */
const changeLocale = (code: string) => {
  i18n.locale.value = code
}
</script>
